import { KeyboardArrowLeft } from '@mui/icons-material'
import { Button, Stack } from '@mui/material'

import { ModalFooterButton } from '@/components/Modal'
import { Footer as CustomFooter } from './Footer'

import { useController } from '../../../hooks/useController'
import { useControllerActions } from '../../../hooks/useControllerActions'
import { useTexts } from '../../../useTexts'

type Props = {
  acknowledgeModal: () => void
}

export function OperationalStorageTipsFooter(props: Props) {
  const { acknowledgeModal } = props
  const texts = useTexts()

  const { navigateToTerritorySettings, onPrevButtonClick } = useControllerActions()
  const { status, close } = useController()

  const submitting = status === 'submitting'

  const onClose = () => {
    acknowledgeModal()
    close?.()
  }

  const onNavigate = () => {
    acknowledgeModal()
    navigateToTerritorySettings()
  }

  return (
    <CustomFooter>
      <Button
        onClick={onPrevButtonClick}
        data-testid="modal-secondary-button"
        data-trackid="modal-secondary-button"
      >
        <KeyboardArrowLeft />
        {texts.prevStepButton}
      </Button>

      <Stack gap={1} direction="row">
        <ModalFooterButton
          testid="modal-tertiary-button"
          data-trackid="modal-tertiary-button"
          disabled={submitting}
          loading={submitting}
          onClick={onNavigate}
        >
          {texts.navigateToTerritorySettingsButton}
        </ModalFooterButton>
        <ModalFooterButton
          testid="modal-primary-button"
          data-trackid="modal-primary-button"
          disabled={submitting}
          loading={submitting}
          onClick={onClose}
          variant="contained"
        >
          {texts.closeButton}
        </ModalFooterButton>
      </Stack>
    </CustomFooter>
  )
}
